import { render, staticRenderFns } from "./due-date-picker.vue?vue&type=template&id=40c07cdd&scoped=true&"
import script from "./due-date-picker.vue?vue&type=script&lang=ts&"
export * from "./due-date-picker.vue?vue&type=script&lang=ts&"
import style0 from "./due-date-picker.vue?vue&type=style&index=0&id=40c07cdd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c07cdd",
  null
  
)

export default component.exports